// extracted by mini-css-extract-plugin
module.exports = {"actionBox":"action-box_actionBox__J9V5g","action":"action-box_action__2UlWe"};